export enum TABLES_COLUMNS {
    tableNumber = 'Table Number',
    tableName = 'Table Name',
    category = 'Category',
    seats = 'Number Of Seats',
    assignedSeating = 'Guest will have assigned seats'
}
